import Login from './Login'
import SignUp from './SignUp'

export default {
  Login,
  SignUp
}
